var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_c('h4',{staticClass:"alert-heading"},[_vm._v(_vm._s(_vm.$t('components.specialOffer.title')))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.specialOffer.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }